import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass/styled-components';
import SdeSection from './SdeSection';
import { Title } from '..';

const titleStyle = { marginTop: '56px' };

function SdeSectionList(props) {
  const {
    sectionData, themeMode, authSdeEnabled, unauthSdeEnabled, selectedCard,
  } = props;
  const sectionsToShow = sectionData.filter(
    (section) => (authSdeEnabled && section.auth) || (unauthSdeEnabled && section.unauth),
  );

  return sectionsToShow.length ? (
    <Box>
      <Title
        fontSize={3}
        style={titleStyle}
      >
        {selectedCard.cardTitle}
      </Title>
      <>
        {sectionsToShow.map((section, index) => (
          <SdeSection
            name={section.sectionName}
            style={index === 0 ? { marginTop: '0px' } : { marginTop: '38px' }}
            description={section.sectionDescription}
            data-testid={section.sectionName.replace(/\s/g, '').toLowerCase()}
            themeMode={themeMode}
            isOpenDefault={index === 0}
            resultList={section.attribute}
            key={section.sectionName}
            auth={section.auth}
            unauth={section.unauth}
          />
        ))}
      </>
    </Box>
  ) : null;
}

SdeSectionList.propTypes = {
  sectionData: PropTypes.array.isRequired,
  themeMode: PropTypes.string.isRequired,
  authSdeEnabled: PropTypes.bool.isRequired,
  unauthSdeEnabled: PropTypes.bool.isRequired,
  selectedCard: PropTypes.object.isRequired,
};

export default SdeSectionList;
